import { isDemo, isDevelopment, isUAT } from '@utilities/Environments';

export const useIsHostedInBrowser = () => 
{
    const hasMobileHeader = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test( navigator.userAgent );
    return isDevelopment() || isDemo() || ( isUAT() && hasMobileHeader == false );
}

export const useIsHostedInJupiter = () => 
{
    return useIsHostedInBrowser() == false;
}